import React, {useEffect, useState} from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import classes from './HomeScreen.module.scss'
import Header from "../../component/Header/Header";
import { ItemInvest } from "../../component/ItemInvest/ItemInvest";
import { FormBuyTokens } from "../../component/FormBuyTokens/FormBuyTokens";
import { useTranslation } from "react-i18next";

const HomeScreen = (props :any) => {

    const[isToken, setToken] = useState(Boolean) 
    const {t} = useTranslation()

    useEffect(() => {
        if(localStorage.getItem('token')){
            setToken(true)
        }
        else{
            setToken(false)
        }
    }, [])

    return(
        <div className={classes.main}>
            <div className="g-container">
                <div className={classes.main__wrapper}>
                    <Header/>
                    <div className={classes.main__wrapper__first}>
                        <div className={classes.main__wrapper__first__info}>
                            <h1 className={classes.main__wrapper__first__info_h1}>{t('main.title')}</h1>
                            <p className={classes.main__wrapper__first__info_text}>{t('main.descr')}</p>
                            {/* <button className={classes.main__wrapper__first__info_btn}>{t('main.button')}</button> */}
                            <a className={classes.main__wrapper__first__info_btn} href="https://cpay24.com/" target="_blank" rel="noreferrer">{t('main.button')}</a>
                        </div>
                        <div className={classes.main__wrapper__first_img}/>
                    </div>
                    <div className={classes.main__wrapper__invest}>
                        <h2 className={classes.main__wrapper__invest_title}>{t('invest.title')}</h2>
                        <div className={classes.main__wrapper__invest__wrapper}>
                            <ItemInvest 
                                img={require('../../img/battery_1.png')} 
                                number = {3} 
                                descr={'Lorem ipsum dolor sit amet consectetur adipiscing elit orcy'}/>
                            <ItemInvest 
                                img={require('../../img/battery_2.png')} 
                                number = {15} 
                                descr={'Lorem ipsum dolor sit amet consectetur adipiscing elit orcy'}/>
                            <ItemInvest 
                                img={require('../../img/battery_3.png')} 
                                number = {25} 
                                descr={'Lorem ipsum dolor sit amet consectetur adipiscing elit orcy'}/>
                            <ItemInvest 
                                img={require('../../img/battery_4.png')} 
                                number = {50} 
                                descr={'Lorem ipsum dolor sit amet consectetur adipiscing elit orcy'}/>  
                        </div>
                        <div className={classes.main__wrapper__invest_blur1}/>
                    </div>
                    <FormBuyTokens navigate={true} status = {props.data.identificationStatus}/>
                    <div className={classes.main__wrapper__explanation}>
                        <img className={classes.main__wrapper__explanation_img} src={require('../../img/illustrationPhone.png')} alt="Phone"/>
                        <div className={classes.main__wrapper__explanation__text}>
                            <h2 className={classes.main__wrapper__explanation__text_h2}>{t('about.title')}</h2>
                            <p className={classes.main__wrapper__explanation__text_descr}>{t('about.descr')}</p>
                            <ul className={classes.main__wrapper__explanation__text__list}>
                                <li className={classes.main__wrapper__explanation__text__list_item}><div className={classes.main__wrapper__explanation__text__list_circle}/>{t('about.about1')}</li>
                                <li className={classes.main__wrapper__explanation__text__list_item}><div className={classes.main__wrapper__explanation__text__list_circle}/>{t('about.about2')}</li>
                                <li className={classes.main__wrapper__explanation__text__list_item}><div className={classes.main__wrapper__explanation__text__list_circle}/>{t('about.about3')}</li>
                                <li className={classes.main__wrapper__explanation__text__list_item}><div className={classes.main__wrapper__explanation__text__list_circle}/>{t('about.about4')}</li>
                                <li className={classes.main__wrapper__explanation__text__list_item}><div className={classes.main__wrapper__explanation__text__list_circle}/>{t('about.about5')}</li>
                                <li className={classes.main__wrapper__explanation__text__list_item}><div className={classes.main__wrapper__explanation__text__list_circle}/>{t('about.about6')}</li>
                                <li className={classes.main__wrapper__explanation__text__list_item}><div className={classes.main__wrapper__explanation__text__list_circle}/>{t('about.about7')}</li>
                                <li className={classes.main__wrapper__explanation__text__list_item}><div className={classes.main__wrapper__explanation__text__list_circle}/>{t('about.about8')}</li>
                            </ul>
                        </div>
                        <div className={classes.main__wrapper__explanation_blur1}/>
                        <div className={classes.main__wrapper__explanation_blur2}/>
                        <div className={classes.main__wrapper__explanation_blur3}/>
                    </div>
                    <div className={classes.main__wrapper__investing}>
                        <div className={classes.main__wrapper__investing__text}>
                            <h2 className={classes.main__wrapper__investing__text_h2}>{t('how.title')}</h2>
                            <p className={classes.main__wrapper__investing__text_descr}>{t('how.how1')}<span>{t('how.how1_1')}</span>{t('how.how1_2')}</p>
                            <p className={classes.main__wrapper__investing__text_descr}>{t('how.how2')}</p>
                            <p className={classes.main__wrapper__investing__text_descr}>{t('how.how3')}</p>
                        </div>
                        <img className={classes.main__wrapper__investing_img} src={require('../../img/Illustration placeholder.png')} alt="Invest" />
                        <div className={classes.main__wrapper__investing_blur1}/>
                    </div>
                    <div className={classes.main__wrapper__footer}>
                        <div className={classes.main__wrapper__footer__desktop}>
                            <img src={require('../../img/logoHeader.png')} alt="Cpay 24" className={classes.main__wrapper__footer_icon}/>
                            <div className={classes.main__wrapper__footer__block}>
                                <div className={classes.main__wrapper__footer__block__info}>
                                    <p className={classes.main__wrapper__footer__block__info_title}>{t('footer.title1')}</p>
                                    {/* <p className={classes.footer__wrapper__block__info_descr}>+48 222472318</p> */}
                                    <a className={classes.main__wrapper__footer__block__info_descr} href='tel:+48123456789'>+48 222472318</a>
                                    <a className={classes.main__wrapper__footer__block__info_descr} href='tel:+48 222472355'>+48 222472355</a>
                                </div>
                                <div className={classes.main__wrapper__footer__block__info}>
                                    <p className={classes.main__wrapper__footer__block__info_title}>{t('footer.title2')}</p>
                                    <p className={classes.main__wrapper__footer__block__info_descr}>{t('footer.descr2_1')}</p>
                                    <p className={classes.main__wrapper__footer__block__info_descr}>{t('footer.descr2_2')}</p>
                                </div>
                                <div className={classes.main__wrapper__footer__block__info}>
                                    <p className={classes.main__wrapper__footer__block__info_title}>{t('footer.title3')}</p>
                                    <p className={classes.main__wrapper__footer__block__info_descr}>{t('footer.descr3_1')}</p>
                                    <p className={classes.main__wrapper__footer__block__info_descr}>{t('footer.descr3_2')}</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.main__wrapper__footer_devider}/>
                        <div className={classes.main__wrapper__footer_rightReserved}>© 2022 — {t('footer.reserved')}</div>
                    </div>
                    {/* <div className={classes.main__wrapper_blur1}/>
                    <div className={classes.main__wrapper_blur2}/>
                    <div className={classes.main__wrapper_blur3}/> */}
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state: any) => ({
    data: state.AuthReducer,
})

export default connect(mapStateToProps, {})(HomeScreen)